const PROJECT_NAME = {

  id: "project_name",
  type: "text",
  props: {
    className: "project_name"
  }

}

const COL_PROJECT_NAME = {

  id: "col_project_name",
  type: "col",
  props: {
    lg: 3,
    md: 4,
    xs: 12,
  },
  children: [PROJECT_NAME]

}

export { PROJECT_NAME, COL_PROJECT_NAME };
